var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplanemodeActive1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "airplanemode_active"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8351_19645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "#D9D9D9",
    stroke: "#357EFF",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8351_19645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "airplanemode_active_2",
    d: "M6.74559 15.7307V14.8998L8.12153 13.878V9.85294L2.27087 11.5829V10.4931L8.12153 7.03324V3.14414C8.12153 2.89893 8.20665 2.69122 8.37688 2.52098C8.54712 2.35074 8.75484 2.26562 9.00004 2.26562C9.24524 2.26562 9.45296 2.35074 9.6232 2.52098C9.79343 2.69122 9.87855 2.89893 9.87855 3.14414V7.03324L15.7292 10.4931V11.5829L9.87855 9.85294V13.8644L11.2545 14.8998V15.7307L9.00004 15.0769L6.74559 15.7307Z",
    fill: "#357EFF",
    stroke: "#357EFF",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplanemodeActive1);
export default __webpack_public_path__ + "static/media/airplanemode_active (1).10a34c963f7e9851eb8b91982362545a.svg";
export { ForwardRef as ReactComponent };